import { render, staticRenderFns } from "./BCXMessengerChatHeader.vue?vue&type=template&id=0ff3108c&scoped=true"
import script from "./BCXMessengerChatHeader.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerChatHeader.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerChatHeader.vue?vue&type=style&index=0&id=0ff3108c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3108c",
  null
  
)

export default component.exports